import {AuthService} from "./AuthService";

// Admin System Health API client. Envelope is res.data.data (standard).
// summary/ is polled by the topbar bell every 60s, so it must stay cheap.
export class SystemHealthService {

    url = `admin/system_health/`;

    // GET admin/system_health/ -> {alerts, resolved, mutes, virtual_alerts, tiles, meta}
    getOverview(resolvedDays = 1) {
        return AuthService.apiGet(this.url + `?resolved_days=${resolvedDays}`)
            .then(res => res.data.data);
    }

    // GET admin/system_health/summary/ -> {active, critical, unseen, worker_down, evaluator_stale, last_run_at}
    getSummary() {
        return AuthService.apiGet(this.url + "summary/").then(res => res.data.data);
    }

    // GET admin/system_health/rules/ -> {rules: [{rule_key, category, domain, cadence_minutes,
    //   thresholds, last_run_at, last_run_ok, active_alerts, muted, muted_until}]}
    getRules() {
        return AuthService.apiGet(this.url + "rules/").then(res => res.data.data);
    }

    // POST admin/system_health/mark_seen/
    markSeen() {
        return AuthService.apiPost(this.url + "mark_seen/", {}).then(res => res.data);
    }

    // POST admin/system_health/mute/ {fingerprint, hours}
    mute(fingerprint, hours) {
        return AuthService.apiPost(this.url + "mute/", {fingerprint: fingerprint, hours: hours})
            .then(res => res.data);
    }

    // DELETE admin/system_health/mute/?fingerprint=...
    unmute(fingerprint) {
        return AuthService.apiDelete(this.url + `mute/?fingerprint=${encodeURIComponent(fingerprint)}`)
            .then(res => res.data);
    }
}
